import { render, staticRenderFns } from "./ColumnMod.vue?vue&type=template&id=8b1bf31c"
import script from "./ColumnMod.vue?vue&type=script&lang=js"
export * from "./ColumnMod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports